import { useEffect, useState } from "react";

export type Size = {
  width: number;
  height: number;
};

type UseWindowDimensions = Size & {
  inner: Size;
  outer: Size;
};

export function useWindowDimensions(
  window: Window = globalThis.window,
): UseWindowDimensions {
  const [inner, setInner] = useState<Size>({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [outer, setOuter] = useState<Size>({
    width: window.outerWidth,
    height: window.outerHeight,
  });

  useEffect(() => {
    function update() {
      setInner({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      setOuter({
        width: window.outerWidth,
        height: window.outerHeight,
      });
    }

    update();

    let w: Window = window;
    do {
      w.addEventListener("resize", update, false);
      w = w.parent;
    } while (w !== w.top);
    return () => {
      let w = window;
      do {
        w.removeEventListener("resize", update);
        w = w.parent;
      } while (w !== w.top);
    };
  }, [window]);

  return {
    ...inner,
    inner,
    outer,
  };
}
